var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.01111 4.32778C2.81111 5.9 4.1 7.18889 5.67222 7.98889L6.89444 6.76667C7.05 6.61111 7.26667 6.56667 7.46111 6.62778C8.08333 6.83333 8.75 6.94444 9.44444 6.94444C9.59179 6.94444 9.7331 7.00298 9.83728 7.10716C9.94147 7.21135 10 7.35266 10 7.5V9.44444C10 9.59179 9.94147 9.7331 9.83728 9.83728C9.7331 9.94147 9.59179 10 9.44444 10C6.93962 10 4.53739 9.00496 2.76621 7.23379C0.995037 5.46261 0 3.06038 0 0.555556C0 0.408213 0.0585316 0.266905 0.162718 0.162718C0.266905 0.0585316 0.408213 0 0.555556 0H2.5C2.64734 0 2.78865 0.0585316 2.89284 0.162718C2.99702 0.266905 3.05556 0.408213 3.05556 0.555556C3.05556 1.25 3.16667 1.91667 3.37222 2.53889C3.43333 2.73333 3.38889 2.95 3.23333 3.10556L2.01111 4.32778Z",
    fill: "#004D91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.07b5821772dfd088416e383303ecb908.svg";
export { ForwardRef as ReactComponent };